import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import i18n from '@/i18n'

Vue.use(Vuetify);

export default new Vuetify({
  lang: { t: (key, ...params) => i18n.t(key, params) },
  theme: {
    themes: {
      light: {
        primary: '#BF0529',
        secondary: 'grey',
        accent: '#8c9eff',
        error: '#b71c1c',
      },
      dark: {
        primary: '#4d4d4d',
        secondary: '#424242',
        accent: '#8c9eff',
        error: '#b71c1c',
      },
    },
  },
})
